import {AfterViewInit, Component, HostBinding, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ChangeStatusEnum} from '@docma-mm-core/model/change-state/change-status.enum';
import {Fault, ViewFault} from '@docma-mm-core/fault/fault';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {TranslateService} from '@ngx-translate/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {BehaviorSubject, combineLatest, firstValueFrom, from, of, Subject} from 'rxjs';
import {MmFaultsViewService} from '../../../services/mm-faults-view.service';
import {MmFaultRightPaneService} from '../../mm-fault-right-pane.service';
import {IPanePage} from '../pane-page';
import {FaultViewEnum, MmFaultViewService} from '../../../../mm-fault/mm-fault-view.service';
import {FaultService} from '@docma-mm-core/fault/fault.service';
import {MmFaultDetailFormComponent} from '../../../../mm-fault/mm-fault-detail-form/mm-fault-detail-form.component';
import {MmProjectPermissionsService} from 'projects/mydocma/mm/src/lib/mm-project/mm-project-permissions-service';
import {ProjectActionPermissionEnum} from '@docma-mm-core/permission/project-action-permission.enum';
import {MmProjectLoaderService} from 'projects/mydocma/mm/src/lib/mm-project/mm-project-loader.service';
import {distinctUntilChanged, filter, map, startWith, switchMap, take} from 'rxjs/operators';
import {FieldMinimal} from '@docma-mm-core/field/field';
import {FieldDefaultNameEnum} from '@docma-mm-core/field/field-default-name.enum';
import {NotificationService} from '@mydocma/component-library/src/lib/notification';
import {MmFaultsSyncService} from '../../../../mm-faults-sync-service';
import {MmFaultsWritingReportingService} from 'projects/mydocma/mm/src/lib/mm-reporting/faults/faults-writing/mm-fault-writing-reporting.service';
import {ConnectivityService} from '@mydocma/core';
import {MydocmaPromptButtonTypeEnum, MydocmaPromptResult, PromptDialogService} from '@mydocma/component-library/src/lib/prompt-dialog';
import {MmFaultChangePageService} from '../../mm-fault-change-page.service';
import {MmFaultRightPanePageEnum} from '../../mm-fault-right-pane.enum';
import {MmFaultsLoaderService} from '../../../../mm-faults-loader.service';
import {MatLegacyTabGroup as MatTabGroup} from '@angular/material/legacy-tabs';
import {MmLayoutStateService} from 'projects/mydocma/mm/src/lib/mm-filter/layout/layout-state.service';
import {MmPlanEditService} from '../../../../mm-plans-view/mm-plan-view/services/mm-plan-edit.service';
import {MmPlansManagerService} from '../../../../mm-plans-view/services/mm-plans-manager.service';
import {AttachmentService} from '@docma-mm-core/attachment/attachment.service';
import {AttachmentType} from '@docma-mm-core/attachment/attachment-type';
import {MmFaultsSplitService} from '../../../services/mm-faults-split.service';
import {PlanEditModeEnum} from '../../../../mm-plans-view/mm-plan-view/services/plan-edit-mode.enum';
import {getShortcutIconName, Shortcut} from '@docma-mm-core/shortcut/shortcut';
import {PersonalizationService} from '@docma-mm-core/personalization/personalization.service';
import {IMmConfig} from '@docma-mm-core/project/project.interface';
import {ConfigProvider} from '@mydocma/common';
import {DynamicFormReadyEvent} from '@mydocma/dynamic-form';
import {ReportService} from 'projects/mydocma/mm/src/lib/mm-reporting/faults/faults-reports/reports.service';
import {FieldConfigurationService} from '../../../../mm-fault/mm-field-configuration/services/field-configuration.service';
import {AppContainerService, AppRightPaneService} from '@mydocma/app-container';
import {FloatButtonsTypesEnum, MmFaultsFabButtonService} from '../../../services/mm-faults-fab-button.service';
import {FloatingActionButton, FloatingActionButtonService} from '@mydocma/component-library/src/lib/floating-action-button';
import {DeviceService} from '@mydocma/core/src/lib/device';
import {Status} from '@docma-mm-core/status/status';
import {MmFaultActionsService} from '../../../../mm-fault-actions.service';
import {MatLegacyMenuTrigger as MatMenuTrigger} from '@angular/material/legacy-menu';
import {MmProjectService} from '../../../../../mm-project/mm-project.service';
import {BpPinLocation, BpPinLocationTargetEnum} from 'projects/mydocma/mm/src/lib/bp-common/models/bp-pin';
import {MmBimViewerService} from 'projects/mydocma/mm/src/lib/mm-bim/mm-bim-view/bim-viewer/mm-bim-viewer.service';
import {MmBimService} from 'projects/mydocma/mm/src/lib/mm-bim/mm-bim.service';
import {PinService} from 'projects/mydocma/mm/src/lib/mm-bim/mm-bim-view/pin-service/pin-service';
import {MmFaultFieldMemoryService} from '../../../../mm-fault/mm-fault-detail-form/services/mm-fault-field-memory.service';
import {MmFaultDetailsService} from '../../../../mm-fault/mm-fault-detail-form/services/mm-fault-detail.service';
import {getTranslatedFilenameForNewPlanSection} from '@mydocma/component-library';
import {getPlanSectionIndexForFault} from '../../../../mm-plans-view/services/mm-plan-section-utils';
import {Pin} from '@mydocma/tile-viewer/lib/pin/pin';
import {Plan} from '@docma-mm-core/plan/plan';
import {SortDirectionEnum} from '@docma-mm-core/sorting/sort-direction.enum';
import {FaultData} from '@docma-mm-core/fault/fault-data';
import {Guid} from 'guid-typescript';
import {PoolEditViewService} from 'projects/mydocma/mm/src/lib/mm-filter/pool/services/pool-edit-view.service';
import {PlatformModeStateService} from 'projects/mydocma/mm/src/lib/mm-offline/services/platform-mode-state.service';
import {FaultPatchService} from '@docma-mm-core/fault/patch/fault-patch-service';
import {FaultSyncService} from '@docma-mm-core/fault/sync/fault-sync.service';
import {buildFaultActionDialog} from '../../../../mm-fault-action-dialog.util';
import {SelectionService} from '@mydocma/component-library/src/lib/selection';
import {MmFaultPinService} from '../../../../mm-fault/services/mm-fault-pin.service';
import { FaultDownloadService } from '@docma-mm-core/fault/download/fault-download.service';
import {Logger} from '@mydocma/common/src/lib/logger';
import {MmPinsLoaderService} from '../../../../mm-pins-loader.service';

enum AttachmentSortingEnum {
  FileDate = 'fileDate',
  AddedOn  = 'addedOn'
}

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-mm-fault-pane-page',
  templateUrl: './mm-fault-pane-page.component.html',
  styleUrls: ['./mm-fault-pane-page.component.scss'],
  providers: [MmBimViewerService, PinService]
})
export class MmFaultPanePageComponent implements OnInit, OnDestroy, IPanePage, AfterViewInit {
  @ViewChild('parentMenuTrigger') parentMenuTrigger: MatMenuTrigger;
  @ViewChild('matMenuShortcutsTrigger', {static: false}) matMenuShortcutsTrigger: MatMenuTrigger;
  @HostBinding('class.hide-mobile-footer') visibleMobileFooterClass = false;
  id: string;
  editFault: ViewFault;
  fault: ViewFault;
  isLocked = false;
  tabIndex = 0;
  faultFormValid = true;
  showTabTexts = true;
  loadStatus = LoadStatusEnum;
  changeStatus = ChangeStatusEnum;
  projectActions = ProjectActionPermissionEnum;
  lockedStatus$ = this.projectLoaderService.statuses.pipe(filter(userPerm => userPerm.loadState.status == LoadStatusEnum.Loaded), map(m => m.data.filter(x => !!x.IsLocked)));

//
// (mmFaultDetailsService.onFaultLoading | async)
// || (faultsViewService.loadingState | async)
// || (faultViewService.faultLoading$ | async)
// || (fault?.loadState?.status === loadStatus.Loading)
// || (triggerLoader$ | async)
// || (faultFieldMemoryService.memoryValuesLoading$ | async)
// || (rightPaneService.saving$ | async)
// || (fieldConfigurationService.loading$ | async)

  /* FOR DEBUGGING PURPOSES */
  // test = combineLatest([
  //             this.changeService.changesPerMask.get(MmFaultRightPanePageEnum.fault),
  //             this.planEditService.planEditMode$,
  //             this.mmFaultDetailsService.onFaultLoading,
  //             this.faultsViewService.loadingState,
  //             this.faultViewService.faultLoading$,
  //             this.faultFieldMemoryService.memoryValuesLoading$,
  //             this.rightPaneService.saving$,
  //             this.fieldConfigurationService.loading$])
  //   .pipe(untilDestroyed(this))
  //   .subscribe(([changesPerMask, planEditMode, onFaultLoading, loadingState, faultLoading$, memoryValuesLoading$, saving$, loading$]) => {
  //     const faultState = (this.fault?.loadState?.status === this.loadStatus.Loading);
  //     const triggerLoader = this.triggerLoader$.value;
  //     console.warn('### DV loading ### ', {planEditMode, changesPerMask, onFaultLoading, loadingState, faultLoading$, faultState, triggerLoader, memoryValuesLoading$, saving$, loading$});
  //   });


  /* FOR DEBUGGING PURPOSES */
  // changed$ = this.changeService.changesPerMask.get(MmFaultRightPanePageEnum.fault)
  //   .pipe(switchMap(dvChanges => this.changeService.changesPerMask.get(MmFaultRightPanePageEnum.plan).pipe(
  //     switchMap(planChanges => this.plansManagerService.selectedPlan$.pipe(
  //       map(selectedPlan => {
  //         const res = (dvChanges || planChanges) && !((selectedPlan == null) && this.planEditService.planEditMode === 3);
  //         console.warn('(dvChanges || planChanges) && !((selectedPlan == null) && this.planEditService.planEditMode === 3)');
  //         console.warn(res);
  //         return res;
  //       })
  //     ))
  //   )) )

  /* FOR DEBUGGING PURPOSES */
  // doneEnabled$ = this.rightPaneService.saving$.pipe(switchMap(saving => this.plansManagerService.selectedPlan$.pipe(
  //   map(selectedPlan => {
  //     const res = !(saving && !(selectedPlan == null));
  //     console.warn('doneENABLED:')
  //     console.warn(res);
  //     return res;
  //   })   //({saving, selectedPlan})
  // )));

  attachmentSortingEnum = AttachmentSortingEnum;
  attachmentSortingTypeEnum = SortDirectionEnum;
  selectedAttachmentSorting = AttachmentSortingEnum.AddedOn;
  selectedAttachmentSortingType = SortDirectionEnum.Descending;

  permissionAddAttachment$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.AddAttachment]);
  permissionDelete$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.DeleteFault]);
  permissionDeletePins$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.DeletePins]);
  permissionDuplicateFault$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.NewFault]);
  permissionDeleteAttachment$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.DeleteAttachment]);
  permissinEditPin$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.EditPins]);

  permissionDefectPoolsAddDefects$ = this.permissionService.permissionDefectPoolsAddDefects$;
  permissionDefectPoolsRemoveDefects$ = this.permissionService.permissionDefectPoolsRemoveDefects$;
  faultsStateSubject = new BehaviorSubject<{ IsAnyFaultLocked: boolean, SelectedFaultsCount: number }>({
    IsAnyFaultLocked: false,
    SelectedFaultsCount: 0
  });
  faultsState$ = this.faultsStateSubject.asObservable();
  // faultChangeSubscription: Subscription;
  faultRightPane = MmFaultRightPanePageEnum.fault;
  planRightPane = MmFaultRightPanePageEnum.plan;
  maxCountFaultsEdit: number;
  maxCountFaultsNewActivity: number;
  maxCountFaultsWritings: number;
  maxCountFaultsReports: number;
  isPaneUndocked = false;
  public fabButton: FloatingActionButton;
  public planEditModeEnum = PlanEditModeEnum;
  @ViewChild(MmFaultDetailFormComponent, {static: false})
  private faultDetail: MmFaultDetailFormComponent;
  @ViewChild('tabGroup', {static: false})
  private tabGroup: MatTabGroup;
  private resizePageSubject = new BehaviorSubject<string>('');
  resizePage$ = this.resizePageSubject.asObservable();
  private fault$ = new BehaviorSubject<ViewFault>(null);
  private refreshHeader$ = new Subject();
  headerText$ = combineLatest([
    this.fault$.pipe(
      switchMap(f => {
        return f?.data$.pipe(map(d => f)) ?? of(null);
      }),
      switchMap(fault => {

        return this.projectLoaderService.fields.pipe(
          filter(f => f.loadState.status === LoadStatusEnum.Loaded),
          map(fields => {
            return ({fault, fields});
          })
        );
      })
    ),
    this.refreshHeader$.pipe(startWith(''))
  ]).pipe(
    switchMap(r => {
      return from(this.getHeader(r[0].fault, r[0].fields.data));
    })
  );
  public shortCutMenuOpenState = false;

  public triggerLoader$ = new BehaviorSubject<boolean>(null);

  @HostBinding('class.mm-pane') protected paneStyle = true;

  constructor(readonly rightPaneService: MmFaultRightPaneService,
              public mmFaultDetailsService: MmFaultDetailsService,
              private readonly translateService: TranslateService,
              private readonly faultService: FaultService,
              public faultFieldMemoryService: MmFaultFieldMemoryService,
              public fmFaultsFabButtonService: MmFaultsFabButtonService,
              readonly faultViewService: MmFaultViewService,
              readonly faultsViewService: MmFaultsViewService,
              readonly faultsLoaderService: MmFaultsLoaderService,
              private readonly projectLoaderService: MmProjectLoaderService,
              public readonly permissionService: MmProjectPermissionsService,
              public readonly writingService: MmFaultsWritingReportingService,
              private readonly notificationService: NotificationService,
              private readonly faultsSyncService: MmFaultsSyncService,
              private readonly connectivityService: ConnectivityService,
              private readonly dialogService: PromptDialogService,
              private readonly layoutStateService: MmLayoutStateService,
              readonly changeService: MmFaultChangePageService,
              public appContainerService: AppContainerService,
              readonly plansManagerService: MmPlansManagerService,
              private readonly attachmentService: AttachmentService,
              public readonly planEditService: MmPlanEditService,
              readonly faultsSplitService: MmFaultsSplitService,
              private configService: ConfigProvider<IMmConfig>,
              private readonly personilizationService: PersonalizationService,
              public readonly reportService: ReportService,
              public fabButtonService: MmFaultsFabButtonService,
              private floatingActionButtonService: FloatingActionButtonService,
              public readonly fieldConfigurationService: FieldConfigurationService,
              private readonly appRightPaneService: AppRightPaneService,
              readonly deviceService: DeviceService,
              public readonly faultActionsService: MmFaultActionsService,
              private readonly mmProjectService: MmProjectService,
              private readonly mmBimViewerService: MmBimViewerService,
              private readonly bimService: MmBimService,
              private readonly poolService: PoolEditViewService,
              public readonly platformModeStateService: PlatformModeStateService,
              private readonly faultPatchService: FaultPatchService,
              private readonly faultSyncService: FaultSyncService,
              public readonly selectionService: SelectionService<ViewFault>,
              private readonly faultPinService: MmFaultPinService,
              private readonly faultDownloadService: FaultDownloadService,
              private readonly pinsLoaderService: MmPinsLoaderService,
              private readonly logger: Logger) {

    this.faultsLoaderService.onFaultsRemoved
      .pipe(untilDestroyed(this))
      .subscribe(removedFaults => {
        if (removedFaults.findIndex(f => f?.uid === this.fault?.uid) !== null) {
          this.discardChanges();
          this.faultsViewService.closeRightPane();
        }
      });

    /* IMMEDIATE UNLOAD DATA OF PREVIOUS PROJECT */
    this.mmProjectService.loadingState
      .pipe(untilDestroyed(this), filter(Boolean))
      .subscribe(() => {
        this.fault = null;
        this.discardChanges();
        this.faultsStateSubject.next({
          IsAnyFaultLocked: false,
          SelectedFaultsCount: 0
        });
      });

    this.fmFaultsFabButtonService.currentSelectedTabIndex$.subscribe(value => {
      this.visibleMobileFooterClass = !!(value);
    });

    this.maxCountFaultsEdit = this.configService.getConfigData().mmConfig.maxCountFaultsEdit;
    this.maxCountFaultsNewActivity = this.configService.getConfigData().mmConfig.maxCountFaultsNewActivity;
    this.maxCountFaultsWritings = this.configService.getConfigData().mmConfig.maxCountFaultsWritings;
    this.maxCountFaultsReports = this.configService.getConfigData().mmConfig.maxCountFaultsReports;

    this.floatingActionButtonService.onFabButtonItemClick.pipe(untilDestroyed(this)).subscribe(value => {
      if (value.id === FloatButtonsTypesEnum.attachments) {
        this.newAttachmentFromFile();
      }
    });

    this.translateService.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe(l => this.refreshHeader$.next(null));

    // this.resizePage$.pipe(
    //   debounceTime(100),
    //   untilDestroyed(this)
    // ).subscribe(p => {
    //   (this.tabGroup?._tabHeader as MatTabHeader).updatePagination();
    // });

    this.rightPaneService.isUndocked$
      .pipe(untilDestroyed(this))
      .subscribe(l => this.isPaneUndocked = l);

    this.projectLoaderService.project
      .pipe(
        distinctUntilChanged(),
        untilDestroyed(this)
      )
      .subscribe((p) => {
        // this.faultChangeSubscription?.unsubscribe();
      });

    this.faultService.onFaultChanged
      .pipe(untilDestroyed(this))
      .subscribe(async fault => {
        this.faultsStateSubject.next({
          IsAnyFaultLocked: (this.fault?.isLocked || this.fault?.data?.IsLocked || (await this.hasLockedActivity(fault))),
          SelectedFaultsCount: 1
        });
      });

  }

  onMenuItemClick() {
     this.faultsViewService.onMenuItemClick();
  }

 async hasLockedActivity(fault: Fault) {
    const lockedStatus: { [id: number]: Status } = {};
    await firstValueFrom(this.lockedStatus$.pipe(map(m => m.map(st => lockedStatus[st.Id] = st))));

    if (Object.keys(lockedStatus).length > 0) {
      return fault.activities.some(a => lockedStatus.hasOwnProperty(a.data.Status.Id));
    }
    return false;
  }

  ngAfterViewInit(): void {
    this.changeService.setFaultDetail(this.faultDetail);
    this.plansManagerService.setFaultDetail(this.faultDetail);

    this.faultDetail.hasChanges$
      .pipe(untilDestroyed(this))
      .subscribe(hasChanges => {
        if (hasChanges) {
          this.changeService.setChanges(MmFaultRightPanePageEnum.fault, this.fault);
        } else if (!hasChanges && !this.fault?.isNew) {
          this.changeService.disableChanges(MmFaultRightPanePageEnum.fault);
        }
      });
  }

  async discardChanges() {
    if (this.fault?.project) {
      await this.faultService.discardChanges(this.fault.project.MyDocmaUid, this.fault.project.BPConnected, this.fault);
    }
    if (this.faultDetail) {
      await this.faultDetail.discardChanges();
    }
    this.fault$.next(this.fault);
  }


  async addToPool() {
    await this.poolService.openPoolFaultToggleEditView(this.fault, true);
  }

  async removeFromPool() {
    await this.poolService.openPoolFaultToggleEditView(this.fault, false);
  }

  ngOnDestroy(): void {
    // this.faultChangeSubscription?.unsubscribe();
  }

  async validate(): Promise<boolean> {
    return this.faultDetail.validate();
  }

  hasChanges(): boolean {
    // if (this.fault && this.fault.unsavedNew) {
    //   return true;
    // }
    return this.changeService.hasChanges(MmFaultRightPanePageEnum.fault) || this.changeService.hasChanges(MmFaultRightPanePageEnum.plan);
  }

  async save(): Promise<boolean> {
    if (!this.fault) {
      return true;
    }
    if (!this.hasChanges() && this.fault.changeState.status === ChangeStatusEnum.NotChanged) {
      return true;
    }
    if (this.faultDetail && !this.faultDetail.validate()) {
      return false;
    }

    const planMode = this.planEditService.planEditMode;
    if (planMode === PlanEditModeEnum.Edit) {
      await this.saveEditPin();
    }

    const changes = await this.faultDetail.getChanges(this.fault.data);


    if ((!changes || Object.keys(changes).length === 0) && this.fault.changeState.status === ChangeStatusEnum.NotChanged) {
      this.changeService.disableChanges(MmFaultRightPanePageEnum.fault);
      if (this.platformModeStateService.isLocalModeEnabled && (planMode === PlanEditModeEnum.Edit || planMode === PlanEditModeEnum.Clipping)){
        return true;
      }
      return false;
    }

    this.setPinTextValue(changes);
    this.fault.addChanges(changes);

    const isNewFault = this.fault?.id === undefined;


    await this.faultService.saveFaultChanges(this.fault.project.MyDocmaUid, this.fault);


    if (isNewFault) {
      await this.mmFaultDetailsService.handlePoolAdditionAfterSave(this.fault);
    }

    this.changeService.disableChanges(MmFaultRightPanePageEnum.fault);
    return true;
  }

  private async setPinTextValue(changes: { [key: string]: any; }) {
    const pinTextValue = await this.faultPinService.getPinTextValue(changes);
    if (pinTextValue) {
      this.fault.pinText = (Object.values(pinTextValue)[0]?.length > 25 ? Object.values(pinTextValue)[0].slice(0, 25) + '...' : Object.values(pinTextValue)[0]);
    }
  }

  async removePins(): Promise<void> {

    /* MMW #397:  needs to be removed (TODO in API und MMK)

    if(await lastValueFrom(this.permissionDeleteAttachment$.pipe(first()))) {

        const deleteAttachmentDialog = (await this.dialogService.showDeleteConfirmationDialog({
          title: this.translateService.instant('MM.dialog.removePlanAttachment.title'),
          content: this.translateService.instant('MM.dialog.removePlanAttachment.content')}))?.value;

        if(deleteAttachmentDialog) {
          const planSections = this.fault.attachments.filter(p => p.data.Type === AttachmentType.PlanSection);
          await this.faultViewService.deleteAttachments(planSections, this.fault);
        } else if(deleteAttachmentDialog === undefined) {
          return;
        }
    }
    */
    if (this.fault.bpPin) {
      this.fault.bpPin.Locations = this.fault.bpPin.Locations.filter(loc => loc.Type != BpPinLocationTargetEnum.plan && loc.Type != BpPinLocationTargetEnum.bim);
      this.fault.addChanges({Pin: this.fault.bpPin, ModifiedOn: new Date()});
    } else {
      this.fault.addChanges({
        PlanId: (this.fault?.data?.PlanId || this.fault?.pin?.FileId),
        PlanPositionX: null, PlanPositionY: null,
        PlanRelativeAnchorToParentPositionX: null,
        PlanRelativeAnchorToParentPositionY: null,
        ModifiedOn: new Date()
      });
    }

    this.fault.pin = null;
    this.fault.bpPin = null;

    await this.faultService.saveFaultChanges(this.fault.project.MyDocmaUid, this.fault);
  }

  async clearData() {
    this.fault = undefined;
    this.fault$.next(undefined);
    await this.changeService.disableChanges(MmFaultRightPanePageEnum.fault);
    await this.changeService.disableChanges(MmFaultRightPanePageEnum.plan);
  }

  setData(data: any) {

    // if (this.faultChangeSubscription && this.fault?.id !== data.fault?.id) {
    //   this.faultChangeSubscription.unsubscribe();
    // }

    this.fault = data.fault;
    this.fault$.next(this.fault);

    this.fault?.loadState$
      .pipe(untilDestroyed(this), filter(f => f.status === LoadStatusEnum.Loaded))
      .subscribe(f => {
        this.faultsStateSubject.next({
          IsAnyFaultLocked: (!!this.fault?.isLocked || !!this.fault?.data?.IsLocked),
          SelectedFaultsCount: 1
        });
      });

    if (data.tabIndex != null) {
      this.tabIndex = data.tabIndex;
    }

    this.faultsStateSubject.next({
      IsAnyFaultLocked: (this.fault.isLocked || this.fault.data.IsLocked),
      SelectedFaultsCount: 1
    });

    if (data.focusField) {
      setTimeout(() => {
        if (this.faultDetail) {
          this.faultDetail.focusField(data.focusField);
        }
      }, 200);
    }

    this.fault?.layoutState.data$.subscribe(f => {

      this.fabButton = {
        id: FloatButtonsTypesEnum.attachments,
        tooltip: 'MM.attachment.createNewFormFile',
        floatingDisabled: false,
        disabled: f?.IsLocked, iconName: 'add'
      } as FloatingActionButton;

      this.fabButtonService.registerButton(this.fabButton);
    });
  }

  ngOnInit() {
    this.faultsViewService.currentFault.pipe(
      filter(p => p?.changeState?.status === this.changeStatus.New)
    ).subscribe(p => this.changeService.setChanges(MmFaultRightPanePageEnum.fault, p));

    this.initSelectedAttachment();
  }

  async initSelectedAttachment() {
    const defaultSorting = AttachmentSortingEnum.AddedOn;
    const defaultSortingType = SortDirectionEnum.Descending;

    const savedAttachmentSorting = await this.personilizationService.getValue('LatestSelected_FaultAttachmentSorting');
    const savedAttachmentSortingTypeValue = await this.personilizationService.getValue('LatestSelected_FaultAttachmentSortingType');
    const savedAttachmentSortingType: SortDirectionEnum = savedAttachmentSortingTypeValue ? parseInt(savedAttachmentSortingTypeValue) : defaultSortingType;

    this.selectedAttachmentSorting = savedAttachmentSorting ? savedAttachmentSorting : defaultSorting;
    this.selectedAttachmentSortingType = savedAttachmentSortingType;
  }

  public async onDoneClick() {
    this.triggerLoader$.next(true);
    setTimeout(async () => {
      try {
        const saved = await this.rightPaneService.saveChanges();
        if (saved) {
          await this.changeService.disableChanges(MmFaultRightPanePageEnum.fault);
        }
        if (this.planEditService.planEditMode === PlanEditModeEnum.Clipping) {
          await this.savePlanClip();
        } else if (this.planEditService.planEditMode === PlanEditModeEnum.Edit) {
          await this.saveEditPin();
        }

        if ((this.deviceService.isMobil() || this.appRightPaneService.dockState?.undocked) && saved) {
          const pageClosed = await this.rightPaneService.closePanePage(false, true, true);
        }

        this.triggerLoader$.next(false);
      } catch (e) {
        this.triggerLoader$.next(false);
        throw e;
      }
    }, 0);
  }

  async savePlanClip(): Promise<void> {
    const plan = this.plansManagerService.selectedPlan;
    const newPin = await this.planEditService.saveEditPin();
    await this.updatePinLocation(newPin.pin, plan);
    await this.planEditService.attachPinOnFault(this.fault, newPin.pin, plan);
    const currentPlan = plan.data.FileName;
    const currentPlanDescription = plan.data.Description ?? plan.data.FileName;

    const planSectionIndex = getPlanSectionIndexForFault(this.fault);
    const fileName = `${Guid.create().toString()}.jpg`;
    const fileDescription = getTranslatedFilenameForNewPlanSection(currentPlanDescription, planSectionIndex, this.translateService, true);

    const attachment = await this.attachmentService.createNewAttachment({Description: fileDescription},
      new File([newPin.snapshot], fileName, {type: 'image/jpeg'}),
      AttachmentType.PlanSection);
    this.fault.addAttachment(attachment);
    await this.faultService.saveFaultChanges(this.fault.project.MyDocmaUid, this.fault);
    this.changeService.disableChanges(MmFaultRightPanePageEnum.plan);
  }

  private async updatePinLocation(pin: Pin, plan: Plan) {
    if ((await firstValueFrom(this.projectLoaderService.project)).data.BPConnected) {
      const bimSectionPlan = this.bimService.getSectionPlan(this.bimService.selectedPlan?.id.toString());

      // if (!pin.data?.bpPin?.Id && !!pin.data?.bpPin?.ExternalId) {
      //   const p = this.pinsLoaderService.getPinByFaultUid(pin.data.bpPin.ExternalId);
      //   pin.data.bpPin.Id = p.Id;
      // }

      const newLocation = {
        Type: BpPinLocationTargetEnum.plan,
        ModelId: bimSectionPlan?.planId || plan.id.toString(),
        VersionId: bimSectionPlan?.versionId || pin?.data?.bpPin?.Locations[0]?.VersionId || plan.data.BpPlan.versions[0].id,
        X: pin.anchor.x,
        Y: pin.anchor.y
      } as BpPinLocation;

      if (!this.fault.bpPin) {
        this.fault.bpPin = {
          Locations: [newLocation],
          ExternalId: this.fault.uid
        };
      } else {
        const existingLocation = this.fault.bpPin?.Locations?.find(loc => loc.ModelId === (bimSectionPlan?.planId || plan.id.toString()) && loc.Type === pin?.data?.bpPin?.Locations[0]?.Type);
        if (!existingLocation) {
          this.fault.bpPin.Locations.push(newLocation);
        } else {
          existingLocation.X = pin.anchor.x;
          existingLocation.Y = pin.anchor.y;
          existingLocation.VersionId = pin?.data?.bpPin?.Locations[0]?.VersionId;
        }
      }

      if (pin.markerAnchor) {
        this.fault.bpPin.Locations[0].Marker = {
          Location: {X: pin.markerAnchor.x, Y: pin.markerAnchor.y}
        };
      }
      this.fault.addChanges({Pin: this.fault.bpPin});

    } else {
      const changes: FaultData = {
        PlanId: plan.id,
        PlanPositionX: pin.anchor.x * 100,
        PlanPositionY: pin.anchor.y * 100,
      };

      if (this.fault.pin?.RelativeAnchorToParentPosX ) {
        changes.PlanRelativeAnchorToParentPositionX = this.fault.pin.RelativeAnchorToParentPosX  * 100;
      }

      if (this.fault.pin?.RelativeAnchorToParentPosY ) {
        changes.PlanRelativeAnchorToParentPositionY = this.fault.pin.RelativeAnchorToParentPosY  * 100;
      }
      this.fault.addChanges(changes);
    }
  }


  async saveEditPin() {
    const plan = this.plansManagerService.selectedPlan;
    const newPin = await this.planEditService.saveEditPin();
    if (newPin) {
      await this.updatePinLocation(newPin.pin, plan);

      const planSectionIndex = getPlanSectionIndexForFault(this.fault);
      const fileName = `${Guid.create().toString()}.jpg`;
      const currentPlanDescription = plan.data.Description ?? plan.data.FileName;
      const fileDescription = getTranslatedFilenameForNewPlanSection(currentPlanDescription, planSectionIndex, this.translateService, true);

      const attachment = await this.attachmentService.createNewAttachment({Description: fileDescription},
        new File([newPin.snapshot], fileName, {type: 'image/png'}),
        AttachmentType.PlanSection);
      this.fault.addAttachment(attachment);
      await this.planEditService.attachPinOnFault(this.fault, newPin.pin, plan);
    }
    this.changeService.disableChanges(MmFaultRightPanePageEnum.plan);
  }

  async onCloseOrBackClick() {
    if (this.planEditService.planEditMode === PlanEditModeEnum.Edit) {
      this.rightPaneService.closePane();
      return;
    }
    await this.faultActionsService.onClose();
  }

  async onDuplicateClick() {
    await this.faultActionsService.onDuplicateClick(this.fault);
  }

  async onDeletePin() {

    if (this.fault?.bpPin?.Locations && this.fault.bpPin.Locations.find(l => l.Type == BpPinLocationTargetEnum.bim)) {
      if (this.appRightPaneService.dockState?.undocked) {
        const title = this.translateService.instant('MM.plan.error.removeBimPin.title');
        const content = this.translateService.instant('MM.plan.error.removeBimPin.content');
        if ((await this.dialogService.showDeleteConfirmationDialog({title, content}))?.value) {
          await this.removePins();
        }
      } else {
        await this.dialogService.showPromptDialog({
          title: this.translateService.instant('MM.plan.error.bimPinCantBeRemoved.title'),
          content: this.translateService.instant('MM.plan.error.bimPinCantBeRemoved.content'),
          buttons: [{
            text: 'Ok',
            type: MydocmaPromptButtonTypeEnum.primary,
            value: false
          }]
        });
        return;
      }
    } else {
      const title = this.translateService.instant('MM.dialog.removePin.title');
      const content = this.translateService.instant('MM.dialog.removePin.content');

      if ((await this.dialogService.showDeleteConfirmationDialog({title, content}))?.value) {
        await this.removePins();
      }
    }
  }

  async onSyncClick() {
    try {
      await this.faultsSyncService.syncFaults([this.fault]);
      this.notificationService.success(await this.translateService.get('MM.syncFault.success').toPromise());
    } catch (error) {
      this.logger.error(error, '', 'MmFaultPanePageComponent');
      this.notificationService.error(await this.translateService.get('MM.syncFault.error').toPromise());
    }
  }

  newAttachmentFromCamera() {
    this.faultViewService.requestToggleView(FaultViewEnum.NewFaultAttachmentFromCamera, {fault: this.fault});
  }

  newAttachmentFromFile() {
    this.faultViewService.requestToggleView(FaultViewEnum.NewFaultAttachmentFromFile, {fault: this.fault});
  }

  setFormState(valid) {
    this.faultFormValid = valid;
  }

  onResize($event) {
    if ($event.contentRect.width < 500) {
      this.resizePageSubject.next('resize');
    }
    this.showTabTexts = window.innerWidth < 500 || $event.contentRect.width > 375;

  }

  onFormReady(event: DynamicFormReadyEvent) {


  }

  IconName(shortcut: Shortcut): string {
    return getShortcutIconName(shortcut);
  }

  public onShortCutButtonCLick($event) {

  }

  async addActivitiesByShortcut($event, shortcut: Shortcut) {
    let viewPointSelection = 1;

    const val = await this.personilizationService.getValue('LatestSelected_ActivityType');
    const ctPerm = await this.permissionService.permissionViewActivitiesCT$.pipe(take(1)).toPromise();
    const coPerm = await this.permissionService.permissionViewActivitiesCO$.pipe(take(1)).toPromise();

    if (val === 1 && ctPerm) {
      viewPointSelection = val;
    } else if (val === 2 && coPerm) {
      viewPointSelection = val;
    } else {
      viewPointSelection = 1;
    }

    this.faultViewService.requestToggleView(FaultViewEnum.NewActivity, {
      faults: [this.fault],
      selectedViewPoint: viewPointSelection,
      selectedStatus: shortcut?.Status
    });
  }

  async onOpenFieldConfiguration() {
    if (!this.connectivityService.isOfflineVal) {
      this.faultViewService.requestToggleView(FaultViewEnum.ConfigFields);
    } else {
      this.dialogService.showNotificationDialog({
        title: this.translateService.instant('MM.field-configuration.offline.title'),
        subTitle: this.translateService.instant('MM.field-configuration.offline.subtitle')
      });
    }


  }

  private async getHeader(fault: Fault, fields: Array<FieldMinimal>): Promise<string> {
    if (!fault) {
      return '';
    }
    if (this.fault.isNew) {
      return this.translateService.get('MM.fault.new').toPromise();
    }
    const fieldNummber = fields.find(f => f.Id === FieldDefaultNameEnum.Number);
    const fieldNummber2 = fields.find(f => f.Id === FieldDefaultNameEnum.Number2);
    const header = await this.translateService.get('MM.fault.faultSingular').toPromise();
    if (fault.loadState.status === LoadStatusEnum.NotLoaded || fault.loadState.status === LoadStatusEnum.Loading) {
      return header;
    }
    if (fieldNummber && fieldNummber2) {
      return `${header}: ${this.fault.data[fieldNummber.Prop]} ${this.fault.data[fieldNummber2.Prop] ?
        '-' : ''} ${this.fault.data[fieldNummber2.Prop] ?? ''}`;
    } else if (fieldNummber) {
      return `${header}: ${this.fault.data[fieldNummber.Prop]}`;
    } else if (fieldNummber2) {
      return `${header}: ${this.fault.data[fieldNummber2.Prop]}`;
    } else {
      return `${header}:`;
    }
  }

  public onShortCutMenuClick($event: MouseEvent) {
    if (!this.deviceService.isDesktop() && this.shortCutMenuOpenState) {
      $event.stopPropagation();
      this.matMenuShortcutsTrigger.closeMenu();
      this.shortCutMenuOpenState = false;
    }
  }

  public onShortCutMenuOpen(): void {
    // open state sets before click, so in order to keep state is shortcut menu open we need to sue setTimout
    setTimeout(() => this.shortCutMenuOpenState = true);
  }

  lockedMessage() {
    return this.translateService.instant('MM.toolbox.actionDeactivated.locked');
  }

  lockedCountExceeded2(countValue: number) {
    return this.translateService.instant('MM.toolbox.actionDeactivated.faultsCountExceeded2', {count: countValue});
  }

  async onAttachmentsSortingSelect(sortBy: AttachmentSortingEnum) {
    await this.personilizationService.setValue('LatestSelected_FaultAttachmentSorting', sortBy);
    this.selectedAttachmentSorting = sortBy;
  }

  async onAttachmentsSortingTypeSelect(sortType: SortDirectionEnum) {
    await this.personilizationService.setValue('LatestSelected_FaultAttachmentSortingType', sortType.toString());
    this.selectedAttachmentSortingType = sortType;

  }

  async onFaultDownloadClick() {
    try {
      let dialogResult: MydocmaPromptResult;
      const viewFault = this.fault as ViewFault;
      const faultPatches = await this.faultPatchService.getByFaultUid(viewFault?.project.MyDocmaUid, this.fault.uid);

      if (faultPatches && faultPatches.length > 0){
        dialogResult = await this.dialogService.showPromptDialog(buildFaultActionDialog('downloadUnsyncedFault', this.translateService));

        if (!dialogResult?.value){
          return;
        }

        const result = await this.faultSyncService.syncAll();
      }

      await this.faultDownloadService.download(this.fault?.project?.MyDocmaUid, [this.fault], true);
    } catch (error) {
      this.notificationService.error(error.message)
    }
  }

  async onRemoveFaultClick() {
    let dialogResult: MydocmaPromptResult;
    const viewFault = this.fault as ViewFault;
    const faultPatches = await this.faultPatchService.getByFaultUid(viewFault?.project.MyDocmaUid, this.fault.uid);
    if (faultPatches && faultPatches.length > 0){
      dialogResult = await this.dialogService.showPromptDialog(buildFaultActionDialog('removeUnsynced', this.translateService));
    } else{
      dialogResult = await this.dialogService.showPromptDialog(buildFaultActionDialog('remove', this.translateService));
    }

    if (!dialogResult?.value) {
      return;
    }

    this.selectionService.stopSelectionMode();
    await this.faultDownloadService.remove(this.fault?.project.MyDocmaUid, this.fault);
    this.faultsLoaderService.isRefreshPending = true;
    await this.faultsLoaderService.refreshFaultsByOverview();
  }

  async onReloadAttachmentsClick() {
    this.faultDownloadService.downloadNotLoadedFaultAttachments(this.fault?.project?.MyDocmaUid, [this.fault]);
  }
}
